import { formatDollars, formatResult } from "../report";

export const emptyCellValue = undefined;

export const tonnesCO2Cell = {
	value: "tonnes CO2-eq",
};
export const tonnesCO2perYearCell = {
	value: "tonnes CO2-eq/yr",
};
export const tonnesCO2PerAcreYearCell = {
	value: "tonnes CO2-eq/ac/yr",
};
export const poundsN20Cell = {
	value: "lb N2O-N",
};
export const acreInchPerAcreCell = {
	value: "ac-in/ac",
};

export function buildHeader(data, user) {
	data.push([
		{
			value: "Operation Name",
			fontWeight: "bold",
		},
		{
			value: user.agopname,
		},
	]);

	data.push([
		{
			value: "Application Date",
			fontWeight: "bold",
		},
		{
			type: Date,
			value: new Date(),
			align: "left",
		},
	]);

	data.push([
		{
			value: "Total Funds Requested",
			fontWeight: "bold",
		},
		{
			value: user.fundsRequested,
			type: Number,
			format: "$#,##0.00",
		},
	]);

	data.push([
		{
			value: "Project Id",
			fontWeight: "bold",
		},
		{
			value: user.id,
		},
	]);
}

export function buildOverallSection(data, reportData) {
	data.push([
		{
			value: "Total Greenhouse Gas Emission Reductions for Proposed Project",
			fontWeight: "bold",
		},
	]);

	data.push([
		{
			value: "Total GHG Benefits per Growing Season",
		},
		{
			value: formatResult(reportData.overallReport.yearlyGHGBenefits),
		},
		tonnesCO2perYearCell,
	]);

	data.push([
		{
			value: "N2O GHG Benefits per Growing Season",
		},
		{
			value: formatResult(reportData.overallReport.convertedN2OBenefits),
		},
		tonnesCO2perYearCell,
	]);

	data.push([
		{
			value: "Pumping GHG Benefits per Growing Season",
		},
		{
			value: formatResult(reportData.pumpingReport.yearlyGHGBenefits),
		},
		tonnesCO2perYearCell,
	]);

	data.push([
		{
			value: "Net GHG Benefits over Useful Life",
		},
		{
			value: formatResult(reportData.overallReport.tenYearGHGBenefits),
		},
		tonnesCO2Cell,
	]);

	data.push([
		{
			value: "GHG Benefits per Acre-Year",
		},
		{
			value: formatResult(reportData.overallReport.ghgBenefitsPerAcreYear),
		},
		tonnesCO2PerAcreYearCell,
	]);

	data.push([
		{
			value: "Total GHG Emission Reductions per Total Funds Requested ",
		},
		{
			value: formatResult(reportData.overallReport.emissionReductionsPerFundsRequested),
		},
	]);
}

export function buildFieldSummary(data, field) {
	const couldNotFetchMessage = "Could not fetch data";

	data.push([
		{
			value: "Field Name",
		},
		{
			value: field?.name,
		},
	]);

	data.push([
		{
			value: "Field Location",
			alignVertical: "center",
		},
		{
			value: field?.latLon.join(", "),
			wrap: true,
		},
		{
			value: "lat/lon",
		},
	]);

	data.push([
		{
			value: "Field APN(s)",
			alignVertical: "center",
		},
		{
			value: field?.apns?.join(", ") ?? couldNotFetchMessage,
			wrap: true,
		},
	]);

	data.push([
		{
			value: "Field Area",
		},
		{
			value: field?.acreage,
			align: "left",
		},
		{
			value: "acres",
		},
	]);

	data.push([
		{
			value: "Soil Type",
		},
		{
			value: field?.results?.soilType?.name ?? couldNotFetchMessage,
		},
	]);

	data.push([
		{
			value: "Assembly District(s)",
			alignVertical: "center",
		},
		{
			value: field?.assemblyDistricts?.join(", ") ?? couldNotFetchMessage,
			wrap: true,
		},
	]);

	data.push([
		{
			value: "Senate District(s)",
			alignVertical: "center",
		},
		{
			value: field?.senateDistricts?.join(", ") ?? couldNotFetchMessage,
			wrap: true,
		},
	]);

	data.push([
		{
			value: "ET Zone",
		},
		{
			value: field?.results?.etZone?.name?.substring(8) ?? couldNotFetchMessage,
		},
	]);

	data.push([
		{
			value: "Census Tract(s)",
			alignVertical: "center",
		},
		{
			value: field?.censusTracts?.join(", ") ?? couldNotFetchMessage,
			wrap: true,
		},
	]);

	data.push([
		{
			value: "In Economically Disadvantaged Area",
		},
		{
			value: field ? getYesNo(field.isEconomicallyDisadvantaged) : emptyCellValue,
		},
	]);
}

export function getYesNo(bool) {
	return bool ? "Yes" : "No";
}

export function getCropPropertyName(year, crop, isPre) {
	var period = isPre ? "pre" : "post";
	var yearText = getNumberText(year);
	var cropText = getNumberText(crop);

	// So many silly things we have to do because the values have pre/post
	// and the year/crop hard-coded into the attribute name. Kids, don't be
	// like Sweep when you grow up.
	return period + "year" + "crop" + cropText + "year" + yearText;
}

function getNumberText(number) {
	return number == 1 ? "one" : number == 2 ? "two" : number == 3 ? "three" : emptyCellValue;
}
